import { render, staticRenderFns } from "./HospitalReportTable.vue?vue&type=template&id=fc68d17c&"
import script from "./HospitalReportTable.vue?vue&type=script&lang=js&"
export * from "./HospitalReportTable.vue?vue&type=script&lang=js&"
import style0 from "./HospitalReportTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports